import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../Components/Themed"
import type { URLMetadataProps } from '../types';
import { SocialComponentApi } from './api';
import { ActivityIndicator, Linking } from 'react-native';
import { useColors } from '../constants/useColors';
import ImageRenderer from './ImageRenderer';

type UrlPreviewCardProps = {
    url:string,
    width:number,
    max_height?:number
    color?:string
}
const UrlPreviewCard = ({ url, color, width, max_height }:UrlPreviewCardProps) => {
    const Colors = useColors();
    const [ data, setData ] = useState<{
        loading:boolean,
        url_metadata?: URLMetadataProps
    }>({
        loading: false
    });
    const { loading, url_metadata } = data;

    useEffect(() => {
        if(!url){ return }
        getMetadata(url)
    },[url])

    const getMetadata = async(url:string) => {
        setData({ ...data, loading:true })
        const metadata = await SocialComponentApi.getUrlMetadata(url);
        setData({
            ...data,
            loading: false,
            url_metadata: metadata
        })

    }

    return (
        <Button float transparent style={{ padding:0, width, marginBottom:10 }} onPress={() => Linking.openURL(url)}>
            {loading ?
            <ActivityIndicator
                style={{ padding:20, alignSelf:'center' }}
                size={'large'}
                color={color ?? Colors.text.h1}
            />
            :<></>}
            {url_metadata?.ogTitle ?
            <View transparent nativeID='CARD' style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                {url_metadata.ogImage?.url ?
                <ImageRenderer
                    image={{ url: url_metadata.ogImage.url, width: parseFloat(url_metadata.ogImage.width), height: parseFloat(url_metadata.ogImage.height) }}
                    width={width - 1}
                    allow_aspect_change
                    max_height={max_height}
                    style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
                />
                :<></>}
                <View type='footer' style={{ padding:10, borderBottomRightRadius: 8, borderBottomLeftRadius:8 }}>
                    <Text theme='h2' style={{ paddingBottom:2, borderBottomWidth:1, borderColor:Colors.borders.light }}>{url_metadata?.ogTitle}</Text>
                    <Text theme='description' style={{ marginTop:4 }}>{url_metadata?.ogDescription}</Text>
                </View>
            </View>
            :
            <View type='header' nativeID='CARD' style={{ borderRadius:8, padding:10 }}>
                <Text theme='action'>{url}</Text>
            </View>
            }
        </Button>
    )
}

export default UrlPreviewCard